import React, { useState, useEffect } from 'react';
import { studentAPI } from '../services/api';
import AdminSidebar from '../components/AdminSidebar';
import AdminNavbar from '../components/AdminNavbar';
import { useSidebar } from '../components/SidebarContext';

const Dashboard = () => {
  const [totalStudents, setTotalStudents] = useState(0);
  const [studentsTakenTest, setStudentsTakenTest] = useState(5);
  const [totalAmountReceived, setTotalAmountReceived] = useState(78);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');

  const { isSidebarOpen, setIsSidebarOpen } = useSidebar();
  const sidebarWidth = isSidebarOpen ? '250px' : '70px';

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await studentAPI.stats.getTotal();
        setTotalStudents(response.data.total);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        setMessage('Error loading data. Please try again.');
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // Inline styles
 const pageStyle = {
  display: 'flex',
  minHeight: '100vh',
  background: 'linear-gradient(to right, #EFF6FF, #F3E8FF, #FEE7EF)',
};

const mainContentStyle = {
  marginLeft: sidebarWidth,
  marginTop: '70px',
  flex: 1,
  padding: '18px', // Reduced from 24px
  transition: 'margin-left 0.3s ease',
};

const cardStyle = {
  backgroundColor: 'white',
  borderRadius: '12px',
  padding: '16px', // Reduced from 20px
  marginBottom: '18px', // Reduced from 24px
  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
};

const cardTitleStyle = {
  fontSize: '1rem', // Reduced from 1.25rem
  fontWeight: '600',
  marginBottom: '10px', // Reduced from 12px
  color: '#1F2937',
};

const cardTextStyle = {
  fontSize: '2rem', // Reduced from 2.5rem
  fontWeight: '700',
  color: '#1F2937',
};

const alertStyle = {
  backgroundColor: '#DBEAFE',
  color: '#1E40AF',
  padding: '10px', // Reduced from 12px
  borderRadius: '8px',
  marginBottom: '12px', // Reduced from 16px
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
};

const closeButtonStyle = {
  background: 'none',
  border: 'none',
  fontSize: '0.875rem', // Reduced from 1rem
  cursor: 'pointer',
  color: '#1E40AF',
};

  return (
    <div style={pageStyle}>
      {/* Sidebar */}
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          height: '100%',
          width: sidebarWidth,
          zIndex: 10,
          transition: 'width 0.3s ease',
        }}
      >
        <AdminSidebar />
      </div>

      {/* Main section */}
      <div style={mainContentStyle}>
        {/* Navbar */}
        <AdminNavbar />

        {/* Page Content */}
        <div>
          <h1 style={{ fontSize: '1.875rem', fontWeight: '700', color: '#1F2937', marginBottom: '24px' }}>
            Admin Dashboard
          </h1>

          {message && (
            <div style={alertStyle}>
              <span>{message}</span>
              <button
                style={closeButtonStyle}
                onClick={() => setMessage('')}
                aria-label="Close"
              >
                ×
              </button>
            </div>
          )}

          {loading ? (
            <div style={{ textAlign: 'center' }}>
              <span style={{ display: 'inline-block', fontSize: '1.5rem', color: '#3b82f6' }}>↻ Loading...</span>
            </div>
          ) : (
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '24px' }}>
              <div style={{ flex: '1 1 300px', ...cardStyle }}>
                <div style={cardTitleStyle}>Total Students</div>
                <div style={cardTextStyle}>{totalStudents}</div>
              </div>
              <div style={{ flex: '1 1 300px', ...cardStyle }}>
                <div style={cardTitleStyle}>Students Taken Test</div>
                <div style={cardTextStyle}>{studentsTakenTest}</div>
              </div>
              <div style={{ flex: '1 1 300px', ...cardStyle }}>
                <div style={cardTitleStyle}>Total Amount Received</div>
                <div style={cardTextStyle}>${totalAmountReceived}</div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;